import React from 'react';
import FittingStatDetailCountContainer from '../containers/FittingStatDetailCountContainer.jsx';
import {
	connect
} from 'react-redux'
import ItemsSerialNoComponent from '../components/ItemsSerialNoComponent.jsx';
import {
	findNoLabelGeneratedCount,
	generateCareLabels,
	deleteCareLabels,
	changeCareLabelValue,
	cleanLabelAlert,
	exportSerialNoList
} from '../actions';

function noSerialNoCountMessage(noLabelGeneratedCount) {
	if (noLabelGeneratedCount > 0) {
		return (<p style={{ color: 'red' }}>尚有 {noLabelGeneratedCount} 筆 item 未產生序號</p>);
	} else {
		return null;
	}
}

function statSerialNoDataListDisplay(orderId, statSerialNoDataList) {
	if (statSerialNoDataList != null) {
		let display = [];
		for (let i = 0; i < statSerialNoDataList.size; i++) {
			let gearName = statSerialNoDataList.get(i).get('gearName');
			let fields = generateFields(statSerialNoDataList.get(i).get('fields'));
			let data = statSerialNoDataList.get(i).get('statSerialNoCount');
			display.push(<div key={i}><h4>{gearName}</h4><FittingStatDetailCountContainer
				orderId={orderId} data={data} fields={fields} /></div>);
		}
		return (<div>{display}</div>);
	}
	return null;
}

function generateFields(fieldList) {
	let fields = {};
	for (let i = 0; i < fieldList.size; i++) {
		let field = fieldList.get(i);
		fields[field.get('key')] = field.get('value');
	}
	return fields;
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['labelReducer', 'orderId']),
	careLabel: state.getIn(['labelReducer', 'careLabel']),
	careLabelValidation: state.getIn(['labelReducer', 'careLabelValidation']),
	alertStyle: state.getIn(['labelReducer', 'alertStyle']),
	alertMessage: state.getIn(['labelReducer', 'alertMessage']),
	noSerialNoCountMessage: noSerialNoCountMessage(state.getIn(['labelReducer', 'noLabelGeneratedCount'])),
	statSerialNoDataListDisplay: statSerialNoDataListDisplay(state.getIn(['labelReducer', 'orderId'])
		, state.getIn(['labelReducer', 'statSerialNoDataList'])),
	serialNoDownloadUrl: state.getIn(['labelReducer', 'serialNoDownloadUrl']),
	roles: state.getIn(['authReducer', 'roles'])
})

const mapDispatchToProps = (dispatch) => ({
	findNoLabelGeneratedCount: (payload) => {
		dispatch(findNoLabelGeneratedCount(payload));
	},
	generateCareLabels: (careLabel) => {
		dispatch(generateCareLabels(careLabel));
	},
	deleteCareLabels: (payload) => {
		let orderId = payload.orderId;
		let r = confirm('警告!!\n將刪除 訂單:' + orderId + '下全部洗標條碼資訊，且無法復原，\n如果已開始生產，請勿刪除!!\n確認刪除 ?');
		if (r === true) {
			dispatch(deleteCareLabels(payload));
		}
	},
	setValue: (id, value) => {
		dispatch(changeCareLabelValue({
			id: id,
			value: value
		}))
	},
	cleanAlert: () => {
		dispatch(cleanLabelAlert());
	},
	exportSerialNoList: (payload) => {
		dispatch(exportSerialNoList(payload));
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	orderId: stateProps.orderId,
	careLabel: stateProps.careLabel,
	careLabelValidation: stateProps.careLabelValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	noSerialNoCountMessage: stateProps.noSerialNoCountMessage,
	statSerialNoDataListDisplay: stateProps.statSerialNoDataListDisplay,
	serialNoDownloadUrl: stateProps.serialNoDownloadUrl,
	findNoLabelGeneratedCount: dispatchProps.findNoLabelGeneratedCount,
	generateCareLabels: () => dispatchProps.generateCareLabels(stateProps.careLabel),
	deleteCareLabels: () => dispatchProps.deleteCareLabels({ orderId: stateProps.orderId }),
	setValue: dispatchProps.setValue,
	cleanAlert: dispatchProps.cleanAlert,
	exportSerialNoList: dispatchProps.exportSerialNoList,
	roles: stateProps.roles
})

const ItemsSerialNoContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ItemsSerialNoComponent)

export default ItemsSerialNoContainer;


// WEBPACK FOOTER //
// ./src/containers/ItemsSerialNoContainer.jsx